export default __webpack_public_path__ + "static/media/Snd_d4.882e0650.mp3";